import { API_URL } from '../../../config'
import store from '../../store'

export default {
  namespaced: true,
  actions: {
    async getReporte({}, payload) {
      // Determinar el endpoint según el tipo de reporte
      let endpoint = '/autodealer-reportes/generar'
      
      if (payload.tipo === 'usados_vendidos') {
        endpoint = '/autodealer-reportes/usados-vendidos'
      }
      
      const response = await fetch(`${API_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      const result = await response.json()
      
      // Normalizar la respuesta para que sea consistente
      if (result.success && result.data) {
        // Si la respuesta tiene estructura { usados: [], cerokm: [] }, mantenerla
        // Si es un array simple, mantenerlo
        return {
          exito: 1,
          data: result.data,
          message: result.message || 'Reporte generado correctamente.'
        }
      }
      
      return result
    },
    async getTiposReportes() {
      const response = await fetch(`${API_URL}/reportes/tipos`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },
    async getDetalle({}, payload) {
      const response = await fetch(`${API_URL}/reportes/detalle`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async generarReporte({}, payload) {
      const response = await fetch(`${API_URL}/reportes/generar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    }
  }
}
